// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {Project} from '../../core/_models'

type Props = {
  row: Row<Project>
  hiddenColumns?: string[]
}

const CustomRow: FC<Props> = ({row, hiddenColumns}) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      if (hiddenColumns && hiddenColumns.includes(cell.column.id)) return null
      return (
        <td
          {...cell.getCellProps()}
          className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
)

export {CustomRow}
